const fsYoutubeEurope = 'https://www.youtube.com/c/FamilySearchEurope'
const youtube = {
  en: 'https://www.youtube.com/c/familysearch',
  es: 'https://www.youtube.com/c/familysearchespanol',
  pt: 'https://www.youtube.com/user/familysearchbrasil',
  it: fsYoutubeEurope,
  fr: fsYoutubeEurope,
  de: fsYoutubeEurope,
}
const twitterEurope = 'https://twitter.com/FamilySearchEur'
const twitter = {
  en: 'https://twitter.com/familysearch',
  es: 'https://twitter.com/FamilySearchEsp',
  pt: 'https://twitter.com/FamilySearchBRA',
  it: twitterEurope,
  fr: twitterEurope,
  de: twitterEurope,
}
const instagramEurope = 'https://www.instagram.com/familysearcheurope'
const instagram = {
  en: 'https://www.instagram.com/familysearch/',
  es: 'https://www.instagram.com/familysearchesp',
  pt: 'https://www.instagram.com/familysearchbrasil',
  it: instagramEurope,
  fr: instagramEurope,
  de: instagramEurope,
}
const facebookAsia = 'https://www.facebook.com/familysearchasia'
const facebook = {
  en: 'https://www.facebook.com/familysearch/',
  es: 'https://www.facebook.com/FamilySearchEsp',
  pt: 'https://www.facebook.com/FamilySearchPT/',
  it: 'https://www.facebook.com/FamilySearchIT/',
  fr: 'https://www.facebook.com/familysearchfr',
  de: 'https://www.facebook.com/FamilySearchDE',
  zh: facebookAsia,
  'zh-hans': facebookAsia,
  ja: facebookAsia,
  ko: facebookAsia,
}

export default function getConnectPlatformLinks(locale = 'en') {
  return {
    youtube: youtube[locale] ?? undefined,
    facebook: facebook[locale] ?? undefined,
    twitter: twitter[locale] ?? undefined,
    instagram: instagram[locale] ?? undefined,
  }
}
